// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.response-table[data-v-7a479b77] {\n  max-height: 40rem;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
